"use client";

import React, { useState } from "react";
import { motion } from "framer-motion";

export const HeroVideo: React.FC = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden z-0 bg-[#050B14]">
      {/* Soft Continuous Vertical Gradient Overlays */}
      {/* Top Overlay: 45% Black */}
      <div
        className="absolute inset-x-0 top-0 h-[40%] z-10 pointer-events-none"
        style={{
          background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.08) 100%)",
        }}
      />
      {/* Middle Overlay: 20% Black */}
      <div
        className="absolute inset-0 z-10 pointer-events-none"
        style={{
          background: "rgba(0, 0, 0, 0.20)",
        }}
      />
      {/* Bottom Overlay & Burgundy Neutral Dark Section Blend: 70% darkness to #050B14 */}
      <div
        className="absolute inset-x-0 bottom-0 h-[55%] z-10 pointer-events-none"
        style={{
          background: "linear-gradient(to top, #050B14 0%, rgba(80, 10, 20, 0.30) 45%, rgba(0, 0, 0, 0.10) 100%)",
        }}
      />

      {/* Background Poster Image */}
      <div
        className={`absolute inset-0 w-full h-full bg-cover bg-center transition-opacity duration-1000 ease-out z-[2] ${
          isVideoLoaded ? "opacity-0" : "opacity-100"
        }`}
        style={{
          backgroundImage: "url('/images/Hero.jpg')",
        }}
      />

      {/* Background Video with Ken Burns Zoom Effect */}
      <motion.div
        animate={{ scale: [1, 1.04, 1] }}
        transition={{
          duration: 36,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{ willChange: "transform" }}
        className="absolute inset-0 w-full h-full transform-gpu"
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          poster="/images/Hero.jpg"
          onLoadedData={() => setIsVideoLoaded(true)}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1500ms] ease-out ${
            isVideoLoaded ? "opacity-100" : "opacity-0"
          }`}
        >
          <source
            src="https://res.cloudinary.com/dcwaaavyg/video/upload/f_auto,q_auto,w_1920,c_limit,vc_auto/v1785053859/Shivalik_University___18_Years_of_Excellence_B.Tech___MBA___BBA___BCA___B.Pharm___B.Sc_Hons_Agri_i0vyqr.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </motion.div>
    </div>
  );
};

export default HeroVideo;
